<template>
    <button class="blueBtn" :name="name" v-on:click="onClick" :disabled="disabled">
        {{ text }}
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ButtonBlue',
    props: {
        text: { type: String, required: true },
        onClick: { type: Function, required: true },
        name: { type: String, required: false },
        disabled: { type: Boolean, required: false },
    },
});
</script>

<style scoped>
.blueBtn {
    background-color: var(--color-principal);
    color: var(--white);
    appearance: none;
    -webkit-appearance: none;
    border: none;
    box-shadow: none;
    transform: none;
}
.blueBtn:disabled {
    background-color: var(--button-color-disabled);
    cursor: default;
}
</style>
